"use client";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const integrations = [
    {
        name: "openai",
        logo: "🤖",
        models: ["gpt-5.2", "gpt-5.1-codex", "gpt-5-codex", "other models..."],
    },
    {
        name: "anthropic",
        logo: "🧠",
        models: ["claude 4.5 opus", "claude 4.5 sonnet", "claude 4.5 haiku", "other legacy models..."],
    },
    {
        name: "google gemini",
        logo: "✨",
        models: ["gemini 3 pro", "gemini 2.5 pro", "gemini 2.5 flash", "other models..."],
    },
    {
        name: "openrouter",
        logo: "🔀",
        models: ["70+ models", "automatic fallbacks"],
    },
];

export function IntegrationShowcase() {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <section ref={ref} className="py-24 px-4 bg-background border-t border-border">
            <div className="container mx-auto max-w-5xl">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">
                        works with your stack
                    </h2>
                    <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                        bring your own api keys. use any provider you trust. switch anytime.
                    </p>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {integrations.map((integration, index) => (
                        <motion.div
                            key={integration.name}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={
                                isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }
                            }
                            transition={{ duration: 0.4, delay: index * 0.1 }}
                            className="group"
                        >
                            <div className="h-full p-6 rounded-xl border border-border bg-card hover:border-foreground/20 transition-colors text-center">
                                <div className="text-4xl mb-4">{integration.logo}</div>
                                <h3 className="text-sm font-semibold mb-2">{integration.name}</h3>
                                <div className="space-y-1">
                                    {integration.models.map((model) => (
                                        <div
                                            key={model}
                                            className="text-xs text-muted-foreground"
                                        >
                                            {model}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6, delay: 0.5 }}
                    className="mt-12 text-center"
                >
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-card border border-border text-sm text-muted-foreground">
                        <span>⚡</span>
                        <span>powered by github apps api</span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
